module.exports = __webpack_public_path__ + "img/triangles.09e93789.jpg";